import { getMethod, postMethod } from '@/services/apis/http-server';
export const getBanners = async (params: any) => {
  try {
    const response = await getMethod(`client/site/slider-list`, params);
    return response.data;
  } catch (error) {
    console.error('Error posting data: ', error);
    return [];
  }
};

export async function registerVoucher(body: any) {
  try {
    const response = await postMethod(`client/discount/register`, body);
    return response;
  } catch (error) {
    console.error('Error:', error);
  }
}

export async function applyCV(body: any) {
  try {
    const response = await postMethod(`careers/apply`, body);
    return response;
  } catch (error) {
    console.error('Error:', error);
  }
}
